// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.card {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.card-header {
  padding: 10px 20px;
  color: white;
  text-align: center;
}

.card-body {
  padding: 0 40px;
  padding-bottom: 20px;
  text-align: center;
}

.card-body img {
  max-width: 100px;
  margin: 20px 0;
  border-radius: 5%;
}

.card-header a {
  color: inherit;
  text-decoration: none;
}

.card-header a:hover {
  text-decoration: underline;
}

.card-body p {
  font-size: 16px;
  color: #333;
  text-align: justify;
  margin-bottom: 1%;
}

#more-info {
  display: flex;
  justify-content: flex-end;
}

#more-info a {
  font-size: 0.9em;
}`, "",{"version":3,"sources":["webpack://./src/styles/Card.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.card {\n  background: white;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 10px 20px;\n  color: white;\n  text-align: center;\n}\n\n.card-body {\n  padding: 0 40px;\n  padding-bottom: 20px;\n  text-align: center;\n}\n\n.card-body img {\n  max-width: 100px;\n  margin: 20px 0;\n  border-radius: 5%;\n}\n\n.card-header a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.card-header a:hover {\n  text-decoration: underline;\n}\n\n.card-body p {\n  font-size: 16px;\n  color: #333;\n  text-align: justify;\n  margin-bottom: 1%;\n}\n\n#more-info {\n  display: flex;\n  justify-content: flex-end;\n}\n\n#more-info a {\n  font-size: 0.9em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
